import { connect } from 'react-redux';
import { Api } from '../../../typings/api';
import { StoreState } from '../../../reducers';
import DriveItemDownloadButton from '../../../components/DriveItem/DownloadButton';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { DownloadManagerState } from '../../DownloadManager/reducer';
import { getMenuButtonIconSrc } from '../../../utils/menuManager';

interface DownloadButtonContainerProps {
	driveItems: Api.DriveItem[];
	icon?: string;
}

const mapStateToProps = (state: StoreState, props: DownloadButtonContainerProps) => {
	const { galleryInfos, downloadManager, driveList, offlineManager: { thumbMap } } = state;
	const { driveItems, icon } = props;
	const { isDeletingAll } = downloadManager;

	const isDownloading = getIsDownloading(downloadManager, driveItems);
	const driveItemId = driveItems[0].id;
	const loaderStep = DownloadManagerUtils.getItemLoaderStep(downloadManager, driveItemId);

	return {
		galleryInfos,
		isDownloading,
		isDeletingAll,
		loaderStep,
		iconSrc: getMenuButtonIconSrc(icon, driveList.driveItems, galleryInfos.config, thumbMap, driveList.resolutions),
	};
};

const getIsDownloading = (
	downloadManager: DownloadManagerState,
	driveItems: Api.DriveItem[] | undefined
): boolean => {
	if (driveItems) {
		return driveItems.some(driveItem => DownloadManagerUtils.isItemDownloading(downloadManager, driveItem.id));
	}

	return false;
};

export default connect(mapStateToProps)(DriveItemDownloadButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DownloadButton/index.tsx